import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import Table, { Column } from 'Components/Table';
import { Timezone } from 'Components/uiControls'
import Modal, { ModalBody } from 'Components/Modal';
import { Pill } from '@gpstrackit/gtc-react-controls';

import { useSelector } from 'react-redux';

const ResumeEvents = (props) => {
  // Intl
  const { messages } = useIntl();

  //Redux States
  const user = useSelector(state => state.securityRedux.user);

  //props 
  const { resumeEvents, setResumeEvents, scanStatuses, getLastScanStatusColor } = props;

  return (
    <Fragment>
      <Modal
        title={messages["emissionCheck_eventsResume"]}
        open={resumeEvents.length > 0}
        size="small"
        handleClose={() => setResumeEvents([])}
        position="right"
      >
        <ModalBody style={{ padding: 25 }}>
          <Table
            data={resumeEvents}
            heightAuto
            hidePagination
            hideSelectableCheckbox
          >
            <Column label={messages["emissionCheck_scanDate"]}>
              {(evt) => {
                return (
                  <div className="paddingBigCell">
                    <Timezone
                      date={evt.scanDate || ''}
                      dateFormat={user?.dateformat}
                      timeFormat="hh:mm"
                      timezone={user?.timeZone || 'UTC'}
                    />
                  </div>
                );
              }}
            </Column>
            <Column label={messages['emissionCheck_status']}>
              {(evt) => {
                return (
                  <div className="paddingBigCell">
                    <Pill item={{ label: scanStatuses.find(s => s.id == evt.scanStatus?.toUpperCase())?.label, color: getLastScanStatusColor(evt.scanStatus?.toUpperCase()) }} />
                  </div>
                );
              }}
            </Column>
            <Column label={messages['emissionCheck_error']}>
              {(evt) => {
                return (
                  <div className="paddingBigCell">
                    {evt.errorMessage}
                  </div>
                );
              }}
            </Column>
          </Table>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default ResumeEvents;